attachEvent('.hero-module__video-toggle', 'click', (ev) => {
  ev.preventDefault();

  const toggleBtn = ev.target.closest('.hero-module__video-toggle');
  const parentEle = toggleBtn.closest('section');
  const videoEle = parentEle.querySelector('.hero-module__video video');

  if (!videoEle) return;

  if (videoEle.paused) {
    videoEle.play();
  } else {
    videoEle.pause();
  }

  toggleBtn.classList.toggle('is-video-paused', videoEle.paused);
});
